import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';

export interface BrowseInfoThemeProps {
  background: string;
}
const styles: ComponentStylesProps<BrowseInfoThemeProps> = {
  background: ({ background }) => ({
    background: `url(${background}) no-repeat center center fixed`,
    backgroundSize: 'cover',
  }),
};

const createStyles = createUseStyles(styles);
export { createStyles };
